<template>
  <div :class="['alert-container', alert.extraClasses]">
    <div v-if="alert.showClose" class="alert-close" @click="removeAlert">&times;</div>
    <div class="warning-message">
      {{alert.message}}
    </div>
    <div class="extra-info">
      {{alert.extraInfo}}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      alert: Object,
      alertKey: String,
    },

    name: 'Alert',

    methods: {
      flash() {
        setTimeout(() => this.removeAlert(), 5000)
      },

      removeAlert() {
        this.$emit('updateAlerts', this.alertKey, {})
      },
    },

    created() {
      if (this.alert?.flashAlert) { this.flash() }
    },
  }
</script>